import { Inject, Injectable } from "@angular/core";
import { AppType, APP_TYPE } from "../../app.type";
import { OCHomeServiceType } from "./OC-home.service.type";
import { OCPost } from "../../../../../shared/models/obsolescence-community/OC-Post";
import { ocPosts } from "../../../app/api.service";
import { BehaviorSubject } from "rxjs";
import { getFilteredOCPosts } from "../../api.service";
import { StringUtils } from "../../../../../shared/utils/string.utils";

const TODAY = "Today";
const YESTERDAY = "Yesterday";

@Injectable()
export class OCHomeService implements OCHomeServiceType {
  postDoc: OCPost = new OCPost();
  posts: OCPost[] = [];
  tags: string[] = [];
  badges: any[] = [];
  isLiked = false;
  editedId = "";
  sortingOrder = "descending";
  selectedValue = "";
  isFilterSelected = false;
  selectedType = "title";
  searchWords: any = {};
  pageNumber = 1;
  limit = 25;
  refreshingPosts = false;

  updatePostsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  async ocPosts() {
    this.posts = await ocPosts(
      this.app.customers.expectCurrent,
      this.pageNumber,
      this.limit
    );
    // this.app.table.sort(this.posts, "ocPost");
    if (this.posts.length > 0) {
      this.app.OCPost.selectedPost = this.posts[0];
    }
  }

  hasEditPermission(selectedItem: any) {
    if (selectedItem == null) {
      return false;
    }
    const { permission } = this.app;
    if (permission.ocPost.edit) {
      return true;
    }
    if (permission.ocPost.editOwn) {
      const createUser = selectedItem.create_user_id;
      if (createUser === this.app.state.userId) {
        return true;
      }
    }
    return false;
  }

  createCleanModel(selectedItem: any) {
    if (selectedItem.type === "ocPost") {
      this.app.OCPost.cleanPost = { ...selectedItem };
      return this.app.OCPost.cleanPost;
    } else {
      this.app.OCComment.cleanComment = { ...selectedItem };
      return this.app.OCComment.cleanComment;
    }
  }

  async sortPosts(order: string) {
    this.pageNumber = 1;
    this.posts = await ocPosts(
      this.app.customers.expectCurrent,
      this.pageNumber,
      this.limit,
      order
    );

    return this.posts;
  }

  async filterOCPosts(type: string, value: string) {
    this.app.spinner.showSpinner();
    this.pageNumber = 1;
    this.posts = await getFilteredOCPosts(
      this.app.customers.expectCurrent,
      type,
      value,
      this.app.OCHome.pageNumber,
      this.app.OCHome.limit
    );
    this.app.OCPost.selectedPost = this.posts[0];
    this.app.OCPost.updatePostSubject.next(true);
    this.app.spinner.hideSpinner();
    return this.posts;
  }

  updateTag(selectedTag: string) {
    this.postDoc.tag = selectedTag;
  }

  filterByTag(selectedTag: string) {
    this.filterOCPosts("tag", selectedTag);
    this.searchWords[this.selectedType] = selectedTag;
  }

  async setBadgeSystem() {
    this.badges = [];
    const options = this.app.field.getFieldSettings(
      this.app.fieldId.personProfile.Management
    ).options;

    if (this.app.profile.profile.sections == null) {
      return;
    }

    const myBadges = this.app.profile.profile.sections.pers.Management;
    if (!StringUtils.isNullOrEmpty(myBadges)) {
      myBadges.forEach((badge: any) => {
        if (options![badge] != null) {
          this.badges.push(options![badge]);
        }
      });
    }
  }

  setBadgeColor(badge: string) {
    const options = this.app.field.getFieldSettings(
      this.app.fieldId.personProfile.Management
    ).options;

    if (options![badge] != null) {
      return options![badge].color;
    }
  }

  setBadgeTooltip(badge: string) {
    const options = this.app.field.getFieldSettings(
      this.app.fieldId.personProfile.Management
    ).options;

    if (options![badge] != null) {
      return options![badge].text.en;
    }
  }

  getTimeInfo(createTime: any) {
    const date = new Date(createTime);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return TODAY;
    } else if (date.toDateString() === yesterday.toDateString()) {
      return YESTERDAY;
    } else {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear());
      return `${day}-${month}-${year}`;
    }
  }

  editDoc(docId: any) {
    this.editedId = docId;
  }

  async updateOCPosts() {
    this.refreshingPosts = true;

    if (this.isFilterSelected) {
      await this.filterOCPosts(
        this.selectedType,
        this.searchWords[this.selectedType]
      );
    } else {
      this.updatePostsSubject.next(true);
    }

    const container = document.getElementById("scroll");
    if (container) {
      container.scrollTop = 0;
    }

    this.refreshingPosts = false;
  }
}
